import domtoimage from 'dom-to-image';

const EMPTY_DATA_URL = 'data:,';
const MIN_CAPTURE_SIZE = 1;
const CAPTURE_TIMEOUT_MS = 5000;

export function isValidBathroomPreviewImage(imageData?: string | null): imageData is string {
  if (!imageData || imageData === EMPTY_DATA_URL || !imageData.startsWith('data:image/')) return false;

  const payloadStart = imageData.indexOf(',');
  return payloadStart >= 0 && imageData.length > payloadStart + 1;
}

export async function captureBathroomPreviewElement(element: HTMLElement, errorLabel: string): Promise<string | null> {
  await waitForLayout();

  const rect = element.getBoundingClientRect();
  const width = Math.round(rect.width);
  const height = Math.round(rect.height);

  if (width < MIN_CAPTURE_SIZE || height < MIN_CAPTURE_SIZE) {
    console.warn(`${errorLabel}: zone de capture vide`, { width, height });
    return null;
  }

  const overlays = element.querySelectorAll<HTMLElement>('.selection-overlay');
  overlays.forEach(overlay => (overlay.style.visibility = 'hidden'));

  try {
    const imageData = await withCaptureTimeout(
      domtoimage.toPng(element, {
        width,
        height,
        style: {
          width: `${width}px`,
          height: `${height}px`,
        },
      }),
      errorLabel
    );

    return isValidBathroomPreviewImage(imageData) ? imageData : null;
  } catch (error) {
    console.error(errorLabel, error);
    return null;
  } finally {
    overlays.forEach(overlay => (overlay.style.visibility = ''));
  }
}

function waitForLayout(): Promise<void> {
  return new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(() => resolve())));
}

function withCaptureTimeout(capture: Promise<string>, errorLabel: string): Promise<string> {
  return Promise.race([
    capture,
    new Promise<string>((_, reject) => {
      setTimeout(() => reject(new Error(`${errorLabel}: délai de capture dépassé`)), CAPTURE_TIMEOUT_MS);
    }),
  ]);
}
